import request from "../utils/request.js"

// 权限管理
// 全查Menu树形
export const getTree = (data) => request({
  url: "/rbac/admin/menu/info/getTree",
  method: "post",
  data
});

// 单查Menu
export const findById = (data) => request({
  url: "/rbac/admin/menu/info/findById",
  method: "post",
  data
});

// 修改Menu
export const update = (data) => request({
  url: "/rbac/admin/menu/info/update",
  method: "post",
  data
});

// 新增Menu
export const insert = (data) => request({
  url: "/rbac/admin/menu/info/insert",
  method: "post",
  data
});

// 刪除Menu
export const deleteMenu = (data) => request({
  url: "/rbac/admin/menu/info/delete",
  method: "post",
  data
});



